import PurchaseModalController from 'components/util/purchase-modal/purchase-modal-controller';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { TRIAL_UPGRADE_TRIGGERED } from 'components/analytics/conversions/constants/actions';

export default class FreeTrialDailyLimitModalController extends PurchaseModalController {
  declare currentDayValue:string;

  static values = {
    currentDay: String,
  }

  connect() {
    super.connect();

    sendTrackingEvent({
      data: {
        action: TRIAL_UPGRADE_TRIGGERED,
        category: 'Trigger-Download_Limit_3',
        label: `Trial_Day-${this.currentDayValue}`,
        non_interaction: true,
      },
    });
  }

  lockForm() {
    this.formSubmitBtnTarget.classList.add('is-loading');
  }

  unlockForm() {
    this.formSubmitBtnTarget.classList.remove('is-loading');
  }
}
